
import { useEffect, useState } from "react";
import api from "./api";
import "./Wiadomosci.css";

function formatujDate(data) {
  if (!data) return null;

  const wartosc = String(data).slice(0, 10);
  const czesci = wartosc.split("-");

  if (czesci.length !== 3) return wartosc;

  return `${czesci[2]}.${czesci[1]}.${czesci[0]}`;
}

export default function Wiadomosci() {
  const [wiadomosci, setWiadomosci] = useState([]);
  const [loading, setLoading] = useState(true);
  const [blad, setBlad] = useState("");

  useEffect(() => {
    let aktywny = true;

    async function pobierzWiadomosci() {
      try {
        const response = await api.get("/wiadomosci.php");

        if (aktywny) {
          setWiadomosci(response.data?.wiadomosci ?? []);
          setBlad("");
        }
      } catch (error) {
        if (aktywny) {
          setBlad(
            error.response?.data?.message ||
              "Nie udało się pobrać wiadomości."
          );
        }
      } finally {
        if (aktywny) {
          setLoading(false);
        }
      }
    }

    pobierzWiadomosci();

    return () => {
      aktywny = false;
    };
  }, []);

  return (
    <section className="wiadomosci">
      <div className="wiadomosci__naglowek">
        <div>
          <h2>Wiadomości i komunikaty</h2>
          <p>Aktualne informacje dla klientów</p>
        </div>

        <span className="wiadomosci__licznik">
          {wiadomosci.length}
        </span>
      </div>

      {loading && (
        <p className="wiadomosci__status">
          Ładowanie wiadomości...
        </p>
      )}

      {!loading && blad && (
        <div className="wiadomosci__blad" role="alert">
          {blad}
        </div>
      )}

      {!loading && !blad && wiadomosci.length === 0 && (
        <div className="wiadomosci__pusto">
          <span aria-hidden="true">📭</span>
          <p>Brak aktualnych wiadomości.</p>
        </div>
      )}

      {!loading && !blad && wiadomosci.length > 0 && (
        <div className="wiadomosci__lista">
          {wiadomosci.map((wiadomosc) => (
            <article
              className={`wiadomosc ${
                Number(wiadomosc.priorytet) === 1
                  ? "wiadomosc--wazna"
                  : ""
              }`}
              key={wiadomosc.id}
            >
              <div className="wiadomosc__tytul">
                <h3>{wiadomosc.tytul}</h3>

                {Number(wiadomosc.priorytet) === 1 && (
                  <span className="wiadomosc__badge">
                    Ważne
                  </span>
                )}
              </div>

              <p className="wiadomosc__tresc">
                {wiadomosc.tresc}
              </p>

              <div className="wiadomosc__stopka">
                <span>
                  Dodano: {formatujDate(wiadomosc.data_dodania)}
                </span>

                {wiadomosc.data_waznosci && (
                  <span>
                    Ważne do: {formatujDate(wiadomosc.data_waznosci)}
                  </span>
                )}

                {wiadomosc.autor && (
                  <span>Autor: {wiadomosc.autor}</span>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
